module.exports = __webpack_public_path__ + "static/media/item-10.6cb02972.jpeg";